/**
 * Configuration for the Hired Notification System
 * Centralizes settings for performance and maintainability
 */

export const HIRED_NOTIFICATION_CONFIG = {
  // Real-time subscription settings
  SUBSCRIPTION: {
    CHANNEL_PREFIX: 'hired_notifications_',
    RECONNECT_DELAY: 1000,
    MAX_RECONNECT_ATTEMPTS: 3,
  },
  
  // Query optimization
  QUERY: {
    BATCH_SIZE: 1, // Only check for one notification at a time
    TIMEOUT: 5000, // 5 second timeout for queries
    RETRY_DELAY: 500, // Delay before retrying failed queries
  },
  
  // UI behavior
  UI: {
    AUTO_CLOSE_DELAY: null, // Don't auto-close - user must manually close
    ANIMATION_DURATION: 300, // milliseconds
    Z_INDEX: 9999,
  },
  
  // Performance settings
  PERFORMANCE: {
    DEBOUNCE_CHECK_DELAY: 500, // Debounce rapid notification checks
    CLEANUP_INTERVAL: 30000, // Clean up subscriptions every 30 seconds if inactive
  },
  
  // Error handling
  ERROR_HANDLING: {
    MAX_RETRY_ATTEMPTS: 3,
    SILENT_FAIL_IN_PRODUCTION: true,
    LOG_ERRORS_IN_DEV: true,
  },
  
  // Security
  SECURITY: {
    VALIDATE_USER_ID: true,
    SANITIZE_CONTENT: true,
  }
};

/**
 * Default fallback values for notification content
 */
export const NOTIFICATION_DEFAULTS = {
  JOB_TITLE: 'Position',
  COMPANY_NAME: 'Company',
  MESSAGE: 'Congratulations! You have been hired.',
};

/**
 * Database field mappings for different schema versions
 */
export const DB_FIELD_MAPPING = {
  JOB_APPLICATIONS: {
    ID: 'id',
    APPLICANT_ID: 'applicant_id', 
    STATUS: 'status',
    ACKNOWLEDGED_AT: 'acknowledged_at',
    UPDATED_AT: 'updated_at',
  },
  JOBS: {
    ID: 'id',
    TITLE: 'title',
    EMPLOYER_ID: 'employer_id',
  },
  USER_PROFILES: {
    ID: 'id',
    COMPANY_NAME: 'company_name',
    FULL_NAME: 'full_name',
  }
};

/**
 * Valid application statuses that trigger notifications
 */
export const NOTIFICATION_TRIGGERS = {
  ACCEPTED: 'accepted',
  // Future: could add more statuses like 'hired', 'offer_extended', etc.
};

export default HIRED_NOTIFICATION_CONFIG;